import axios from '@/plugins/axios'

export const get = async opts => {
  const { results, next } = await axios.get('/v1/collections', opts)
  return {
    results: results.map(i => ({
      ...i,
      ownerId: i.owner,
      members: (i.membersPreview || []).map(t => ({
        ...t,
        userId: t.user?._id,
        collectionId: i._id,
      })),
    })),
    next,
  }
}

export const getPinned = async opts => {
  const { results, next } = await axios.get('/v2/collections/pinned', opts)
  return {
    results: results.map(i => ({
      ...i,
      ownerId: i.owner,
      members: (i.membersPreview || []).map(t => ({
        ...t,
        userId: t.user?._id,
        collectionId: i._id,
      })),
    })),
    next,
  }
}

export const create = (data, ...o) => axios.post('/v1/collections', data, ...o)

export const getId = async (id, ...o) => {
  const collection = await axios.get(`/v1/collections/${id}`, ...o)
  return {
    ...collection,
    ownerId: collection.owner,
    members: collection.membersPreview.map(t => ({
      ...t,
      userId: t.user?._id,
      collectionId: collection._id,
    })),
  }
}

export const edit = (id, data, ...o) => axios.patch(`/v1/collections/${id}`, data, ...o)
export const remove = (id, ...o) => axios.delete(`/v1/collections/${id}`, ...o)
export const removeBulk = (data, ...o) => axios.post('/v2/collections/bulk/remove', data, ...o)

// members
export const members = async (cId, ...o) => {
  const { results, next } = await axios.get(`/v1/collections/${cId}/members`, ...o)

  return {
    results: results.map(membership => ({
      ...membership,
      userId: membership.user?._id,
      collectionId: cId,
    })),
    next,
  }
}

export const getMember = async (cId, mId, ...o) => {
  const membership = await axios.get(`/v1/collections/${cId}/members/${mId}`, ...o)
  return {
    ...membership,
    userId: membership.user?._id,
    collectionId: cId,
  }
}

export const inviteEmails = (cId, data, ...o) => axios.post(`/v1/collections/${cId}/members`, data, ...o)
export const inviteEmailsBulk = (data, ...o) => axios.post('/v2/collections/bulk/invite', data, ...o)
export const acceptInvite = (cId, data, ...o) => axios.post(`/v1/collections/${cId}/members/accept`, data, ...o)
export const inviteInfo = (cId, data, ...o) => axios.post(`/v1/collections/${cId}/members/info`, data, ...o)
export const updateMember = (cId, mId, data, ...o) => axios.patch(`/v1/collections/${cId}/members/${mId}`, data, ...o)
export const removeMember = (cId, mId, ...o) => axios.delete(`/v1/collections/${cId}/members/${mId}`, ...o)
export const removeMemberBulk = (data, ...o) => axios.post('/v2/collections/bulk/remove-member', data, ...o)

// share link
export const shareLink = (cId, ...o) => axios.get(`/v1/collections/${cId}/members/link`, ...o)
export const shareLinksBulk = (data, ...o) => axios.post('/v2/collections/bulk/get-share-links', data, ...o)
export const shareLinkInfo = (cId, data, ...o) => axios.post(`/v1/collections/${cId}/members/link/info`, data, ...o)
export const createShareLink = (cId, data, ...o) => axios.post(`/v1/collections/${cId}/members/link`, data, ...o)
export const createShareLinkBulk = (data, ...o) => axios.post('/v2/collections/bulk/create-shared-links', data, ...o)
export const removeShareLink = (cId, lId, ...o) => axios.delete(`/v1/collections/${cId}/members/link/${lId}`, ...o)
export const editShareLink = (cId, lId, data, ...o) => axios.patch(`/v1/collections/${cId}/members/link/${lId}`, data, ...o)
export const editShareLinkBulk = (data, ...o) => axios.post('/v2/collections/bulk/edit-shared-links', data, ...o)
export const deleteShareLinkBulk = (data, ...o) => axios.post('/v2/collections/bulk/delete-shared-links', data, ...o)
export const acceptShareLink = (cId, data, ...o) => axios.post(`/v1/collections/${cId}/members/link/accept`, data, ...o)

// pin
export const pinCollection = (id, data, ...o) => axios.post(`/v2/collections/${id}/pin`, data, ...o)
export const unpinCollection = (id, ...o) => axios.delete(`/v2/collections/${id}/pin`, ...o)

// sub-collection pin
export const pinSubCollection = (collectionId, subCollectionId, data, ...o) =>
  axios.post(`/v2/collections/${collectionId}/sub-collections/${subCollectionId}/pin`, data, ...o)
export const unpinSubCollection = (collectionId, subCollectionId, ...o) =>
  axios.delete(`/v2/collections/${collectionId}/sub-collections/${subCollectionId}/pin`, ...o)

// mixed pinned content (items + sub-collections inside a collection)
export const getMixedPinned = (collectionId, opts) =>
  axios.get(`/v2/collections/${collectionId}/pinned`, opts)

// public collections
export const getPublicCollections = async (username, opts) => {
  const { owner, results, next } = await axios.get(`/v1/public/u/${username}/collections`, opts)
  return {
    owner,
    results: results.map(i => ({
      ...i,
      ownerId: i.owner?._id || i.owner,
      members: (i.membersPreview || []).map(t => ({
        ...t,
        userId: t.user?._id,
        collectionId: i._id,
      })),
    })),
    next,
  }
}

export const getPublicCollection = async (username, collectionId) => {
  const collection = await axios.get(`/v1/public/u/${username}/collections/${collectionId}`)
  return {
    ...collection,
    ownerId: collection.owner?._id || collection.owner,
    members: (collection.membersPreview || []).map(t => ({
      ...t,
      userId: t.user?._id,
      collectionId: collection._id,
    })),
  }
}

export const getPublicCollectionByShortId = (shortId) =>
  axios.get(`/v1/public/c/${shortId}`)

export const getPublicCollectionItems = (username, collectionId, opts) =>
  axios.get(`/v1/public/u/${username}/collections/${collectionId}/items`, opts)

export const getPublicMixedPinned = (username, collectionId, opts) =>
  axios.get(`/v1/public/u/${username}/collections/${collectionId}/pinned`, opts)

export const getPublicCollectionPinnedItems = (username, collectionId, opts) =>
  axios.get(`/v1/public/u/${username}/collections/${collectionId}/items/pinned`, opts)

export const getPublicPinnedCollections = async (username, opts) => {
  const { owner, results, next } = await axios.get(`/v1/public/u/${username}/collections/pinned`, opts)
  return {
    owner,
    results: results.map(i => ({
      ...i,
      ownerId: i.owner?._id || i.owner,
      members: (i.membersPreview || []).map(t => ({
        ...t,
        userId: t.user?._id,
        collectionId: i._id,
      })),
    })),
    next,
  }
}

export const getPublicSubCollections = async (username, collectionId, opts) => {
  const { results, next } = await axios.get(`/v1/public/u/${username}/collections/${collectionId}/sub-collections`, opts)
  return {
    results: results.map(i => ({
      ...i,
      ownerId: i.owner?._id || i.owner,
      members: (i.membersPreview || []).map(t => ({
        ...t,
        userId: t.user?._id,
        collectionId: i._id,
      })),
    })),
    next,
  }
}

export const getPublicCollectionStats = (username, collectionId) =>
  axios.get(`/v1/public/u/${username}/collections/${collectionId}/stats`)

export const getPublicCollectionPopularTags = (username, collectionId) =>
  axios.get(`/v1/public/u/${username}/collections/${collectionId}/tags/popular`)

// --- Public collection item endpoints ---

export const getPublicCollectionItem = async (username, collectionId, itemId) => {
  const item = await axios.get(`/v1/public/u/${username}/collections/${collectionId}/items/${itemId}`)
  return {
    ...item,
    ownerId: item.owner,
    tagIds: item.tags?.map(t => t._id) || [],
    tags: item.tags?.map(t => ({ ...t, ownerId: t.owner })) || [],
  }
}

// Comments
export const getPublicCollectionItemComments = async (username, collectionId, itemId, opts) => {
  const { results, next } = await axios.get(
    `/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/comments`,
    opts,
  )
  return {
    results: results.map(i => ({
      ...i,
      userId: i.user._id,
      resourceId: itemId,
      resourceType: 'collectionitems',
    })),
    next,
  }
}

export const postPublicCollectionItemComment = (username, collectionId, itemId, data) =>
  axios.post(`/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/comments`, data)
    .then(i => ({
      ...i,
      userId: i.user,
      resourceId: itemId,
      resourceType: 'collectionitems',
    }))

export const deletePublicCollectionItemComment = (username, collectionId, itemId, commentId) =>
  axios.delete(`/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/comments/${commentId}`)

// Likes
export const getPublicCollectionItemLikes = async (username, collectionId, itemId, opts) => {
  const { results, next } = await axios.get(
    `/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/likes`,
    opts,
  )
  return {
    results: results.map(i => ({
      ...i,
      userId: i.user._id,
      resourceId: itemId,
      resourceType: 'collectionitems',
    })),
    next,
  }
}

export const postPublicCollectionItemLike = (username, collectionId, itemId) =>
  axios.post(`/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/likes`)
    .then(i => ({
      ...i,
      userId: i.user,
      resourceId: itemId,
      resourceType: 'collectionitems',
    }))

export const deletePublicCollectionItemLike = (username, collectionId, itemId) =>
  axios.delete(`/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/likes`)

// ==================== PUBLIC COLLECTION ITEM COPY ====================

export const copyPublicCollectionItem = (username, collectionId, itemId, data) =>
  axios.post(`/v1/public/u/${username}/collections/${collectionId}/items/${itemId}/copy`, data)

export const copyPublicCollectionItemsBulk = (username, collectionId, data) =>
  axios.post(`/v1/public/u/${username}/collections/${collectionId}/items/bulk/copy`, data)
